<template>
<div v-cloak class="transfer-right-body" id="emailTransfer" v-if="transferPageShow" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.05)">
    <div class="task-top">
        <div class="task-top-position">
            <div class="transfer-name">{{$t('language.leftBanner.emailTransfer')}}</div>
            <div class="transfer-description">{{$t('language.emailTransfer.description')}}</div>
        </div>
    </div>
    <div class="task-middle">
        <div class="task-box-position">
            <div class="task-box" :class="boxFrom">
                <div class="task-box-title">{{$t('language.cloudTransfer.from')}}</div>
                <div class="task-box-btns" @click="openAddEmailDrawer()">
                    <div class="task-box-btns-icon addEmailIcon-blue"></div>
                    <div>{{$t('language.common.addEmail')}}</div>
                </div>
                <el-scrollbar style="height:calc(100% - 108px);" ref="scrollbarAim">
                    <transferAimTree ref="transferAimTree"></transferAimTree>
                </el-scrollbar>
            </div>
            <div class="task-box-middle">
                <div class="arrow-position"></div>
            </div>
            <div class="task-box" :class="boxTo">
                <div class="task-box-title">{{$t('language.cloudTransfer.to')}}</div>
                <div class="task-box-btns" @click="openAddCloudDrawer()">
                    <div class="task-box-btns-icon addCloudIcon-blue"></div>
                    {{$t('language.common.addCloud')}}
                </div>
                <el-scrollbar style="height:calc(100% - 108px);" ref="scrollbarSource">
                    <transferSourceTree ref="transferSourceTree"></transferSourceTree>
                </el-scrollbar>
            </div>
        </div>
        <div class="definite-operating">
            <div style="position:relative;">
            <div class="operating-options" @click="openOptionsDialog()">
                <div class="icon-util setting" style="float:left;"></div>
                <div class="operating-position">{{$t('language.common.options')}}</div>
            </div>
            <div class="operating-schedule" @click="openSchduleDialog()">
                <div class="icon-util" @click.stop="checkedOpen()" :class="checkedSchedule?'check':'nocheck'" style="float:left;"></div>
                <div class="operating-position">{{$t('language.common.schedule')}}</div>
            </div>
            <div class="operating-schedule" @click="openFilterDialog()">
                <div class="icon-util funnel" style="float:left;"></div>
                <div class="operating-position">{{$t('language.common.emailFilter')}}</div>
            </div>
            <edit-input ref="editInput" :inputValue=inputValue :submitTaskName="submiTransfertName"></edit-input>
            <button class="transfer-button" v-if="!checkedSchedule" @click="transferNow()">
                <div class="icon transfer-icon-position emailTransfer"></div>
                <div style="float:left;">{{$t('language.emailTransfer.transferNow')}}</div>
            </button>
            <div class="schedule-button" v-if="checkedSchedule" @click.stop="transferAddTask()">
                <div class="text-button-position">
                    <div class="icon transfer-task-position cloudTransfer"></div>
                    <div style="float:left;color:#fff;">{{$t('language.cloudTransfer.addTaskOnly')}}</div>
                </div>
                <div class="more-button-position" @click.stop="addTaskIconShow()">
                    <div class="icon-util  transfer-up-position" :class="addTaskShow?'transfer-up':'transfer-down'"></div>
                </div>
            </div>
            <div class="addTask" v-if="addTaskShow" @click.stop="addTransferNow()">
                <div class="task-type-icon-min transfer-blue-min transfer-blue-position"></div>
                <div style="float:left;">{{$t('language.cloudTransfer.addTaskNow')}}</div>
            </div>
            <transition name="flow">
                <div class="flow-icon" v-show="flowShow" id="transferFlow">
                    <div class="icon transfer-task-position cloudTransfer flow-icon-position"></div>
                </div>
            </transition>
        </div>
        </div>
    </div>
    <div class="task-buttom"></div>
    
    
    <transferOptionsDialog ref="transferOptionsDialog"></transferOptionsDialog>
    <transferScheduleDialog ref="transferScheduleDialog"></transferScheduleDialog>
    <upgradeNewDialog ref="upgradeNewDialog"></upgradeNewDialog>
    <noticeDialog ref="noticeDialog"></noticeDialog>
    <remindBindEmailDialog ref="remindBindEmailDialog"></remindBindEmailDialog>
    <drawer ref="addEmailDrawer" :drawerName="'addEmailDrawer'" :openPageName="'addEmailPage'"></drawer>
    <drawer ref="addCloudDrawer" :drawerName="'addCloudDrawer'" :openPageName="'addCloudPage'"></drawer>
    <filterOptionDialog ref="filterOptionDialog"></filterOptionDialog>
</div>
</template>

<script>
//显示账号升级弹窗
import upgradeNewDialog from "@/components/popup/upgrade_popups/upgrade_account_new_popup";
import commonUtils from "@/js/workspace/common_util.js";

import transferSourceTree from "@/components/common/trees/transfer_single_tree";
import transferAimTree from "@/components/common/trees/transfer_multi_email_tree";

import transferOptionsDialog from "@/components/popup/email_transfer_popups/transfer_options_popup";
import transferScheduleDialog from "@/components/popup/cloud_transfer_popups/task_schedule_popup";
import editInput from '@/components/common/input/edit_input';
import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
import taskListUtils from "@/js/workspace/task_list_util.js";
import noticeDialog from "@/components/popup/cloud_transfer_popups/transfer_notice_popup";
import remindBindEmailDialog from "@/components/popup/personal_center_popups/remind_bind_email_popup";

import drawer from "@/components/drawer/formwork/basic_drawer";
import commonstate from '@/js/constant.js';
import filterOptionDialog from "@/components/popup/email_transfer_popups/filter_option_popup";
export default {
    name: "cloudTransfer",
    components: {
        transferSourceTree,
        transferAimTree,
        "edit-input": editInput,
        transferOptionsDialog,
        transferScheduleDialog,
        upgradeNewDialog,
        noticeDialog,
        remindBindEmailDialog,
        drawer,
        filterOptionDialog,
    },
    data() {
        return {
            flowShow: false,
            transferPageShow: true,
            singleDrives: {},
            mulitDrives: [],
            hasSelect: true,
            hasSelectItemsMore: false,
            hasSelectItems: false,
            inputValue: commonUtils.getTaskTxt(this),
            checkedSchedule: false,
            hoverCurrent: -1,
            allLength: 0,
            folderType: 'small-file type-icon-position',
            fileType: 'icon type-drive-position',
            addTaskShow: false,
            pOptions: {
                replace: 4,
                isChar: 1,
                keepRoot:1,
                attachment: true,
                conversationQuoted: true,
                onlyLastMail: false,
                delWatermark: false,
                way: "cloudEmail",
            },
            pSchedules: {},
            boxFrom: '',
            boxTo: '',
            addTaskFlag: true,
            loading: false
        };
    },
    watch: {
        //监听任务列表，默认名称跟着变化
        '$store.state.taskListArr': function (newValue, oldValue) {
            let allTasklistData = this.$store.state.taskListArr;
            commonUtils.changeTaskNameLength(allTasklistData,this);
        },
        '$store.getters.getUsersDrives': function(newValue, oldValue) {
            let that = this;
            if (this.$store.getters.getUsersDrives.length) {
                if(oldValue&&oldValue.length&&newValue.length!=oldValue.length) {
                    this.$refs.transferSourceTree.refreshModel();
                    this.$refs.transferAimTree.refreshModel();
                }
            }
        },
    },
    created() {
        //初始化界面名称
        commonUtils.initPageName(this,'cloudTransfer');
    },
    mounted() {
        //禁用拖拽功能
        commonUtils.dragDisAble('cloudTransfer',this);
    },
    methods: {
        openAddEmailDrawer(){
            this.$refs.addEmailDrawer.init('addEmailPage');
        },
        openAddCloudDrawer(){
            this.$refs.addCloudDrawer.init('addCloudPage');
        },
        onDrag: function (e) {
            e.stopPropagation();
            e.preventDefault();
        },
        addTaskIconShow() {
            this.addTaskShow = !this.addTaskShow;
        },
        //提交传输任务名
        submiTransfertName() {
        if(this.$refs.editInput.value.length > 255){
             this.$refs.editInput.value =  this.$refs.editInput.oldNameValue;
                     this.$toast({
                     text: this.$t('language.taskList.taskNameRule'),
                     type: 'fail',
                     idValue: "emailTransfer"
                     });
                     return false;
          }
          commonUtils.submiTaskName(this);
        },
        //删除多源选中框里的数据
        removeItem(index, id) {
            let that = this;
            //删除数据
            this.mulitDrives.splice(index, 1);
            //取消该项的选中
            this.$refs.transferAimTree.$refs.tree.setChecked(id, false);
            $.each(this.$refs.transferAimTree.checkedNodes, function (nodeIndex, nodeItem) {
                if (nodeItem.id == id) {
                    that.$refs.transferAimTree.checkedNodes.splice(nodeIndex, 1);
                    return false;
                }
            });
        },
        //打开过滤弹窗
        openFilterDialog() {
            this.$refs.filterOptionDialog.init();
        },
        //打开设置弹窗
        openOptionsDialog() {
            //显示第一页
            this.$refs.transferOptionsDialog.activeName = "first";
            if(this.pOptions.keepRoot){
                this.$refs.transferOptionsDialog.options.keepRoot=1;
                this.$refs.transferOptionsDialog.$refs.tab1.init();
            }
            this.$refs.transferOptionsDialog.init(this.pOptions);
        },
        //打开设置时间弹窗
        openSchduleDialog() {
            this.$refs.transferScheduleDialog.taskSchduleShow = true;
            this.$refs.transferScheduleDialog.initPopup();
        },
         //当用户取消选择时间设置时默认传参数为‘Now’
        checkedOpen() {
            if (this.checkedSchedule) {
                this.checkedSchedule = false;
                this.addTaskShow = false;
                this.pSchedules = {
                    type: "Now"
                }
                this.clearAllTableData();
            } else {
                this.$refs.transferScheduleDialog.$refs.daily.checkArr = [0];
                this.openSchduleDialog();
            }
        },
        //清除界面数据
        clearAllTableData() {
            this.$refs.transferScheduleDialog.$refs.weekly.weekArr = [];
            this.$refs.transferScheduleDialog.$refs.monthly.monthArr = [];
            this.$refs.transferScheduleDialog.$refs.daily.checkArr = [];
            this.$refs.transferScheduleDialog.$refs.daily.dailyTimeArr = [];
            this.$refs.transferScheduleDialog.$refs.daily.dailyDisableFlage = true;
            this.$refs.transferScheduleDialog.$refs.daily.onceDisableFlage = true;
            this.$refs.transferScheduleDialog.oldSchedules = {};
            this.$refs.transferScheduleDialog.schedules = {};
        },
        matchfileType(fileName) {
            return commonUtils.matchfileTypes(fileName);
        },
        //自动点击确定
        autoSubmit() {
            this.$refs.transferAimTree.multiSubmit();
            this.$refs.transferSourceTree.singleSubmitForEmailSync();
        },
        transferNow() {
            //判断是否是临时用户，然后提醒用户进行绑定邮箱
            let user=commonUtils.getUser();
            if(commonUtils.testUserIsTourist(user)){
                this.$refs.remindBindEmailDialog.remindBindEmailShow=true;
                return false;
            }
            this.autoSubmit();
            let that = this;
            var executeData;
            //如果用户流量不足，则显示付费升级弹窗
            let usedTraffic = user.usedBytes;
                // if(user.vip&&user.payLevel>1){
                    //  usedTraffic = user.payUsedTraffic;
                // }
            if (user.totalBytes != -1 && usedTraffic >= user.totalBytes) {
                var upgradeNewDialog = this.$refs.upgradeNewDialog;
                upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_traffic');
                upgradeNewDialog.curItem = 'traffic';
                upgradeNewDialog.isShow = true;
                return false;
            }
            //如果用户源和目标都选择了
            if (this.mulitDrives.length && this.singleDrives.name) {
                let matched = this.$refs.filterOptionDialog.getFilterRule();
                if(matched){
                    this.pOptions.matched = matched
                    this.pOptions.pattern = "gmailFilter";
                }
                let addData = new taskTransferUtils.addTaskData(user.id ,1,this.inputValue, taskTransferUtils.createTransferFromItems(this.mulitDrives), taskTransferUtils.createTransferToItems(this.singleDrives), this.pOptions, {
                    type: 'Now',
                    clientTime: commonUtils.getNowDateFormat(),
                });
                addData.options.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;//传时区
                if (!addData.n) {
                    this.$refs.editInput.cancelTaskName();
                    addData.n = this.$refs.editInput.oldNameValue;
                }
                //如果选择源的数量大于11条并且用户勾选了发送邮件，则出现提醒弹窗
                if (addData.fromItems.length >= 11 && addData.options.email) {
                    this.$refs.noticeDialog.noticeShow = true;
                    this.$refs.noticeDialog.transferFlag = 0;
                    this.$refs.noticeDialog.addData = addData;
                } else {
                    //开始传输数据
                    this.$nextTick(function () {
                        this.transferNowRequest(addData);
                    });
                }//如果未选择数据，div抖动
            } else if ((!this.mulitDrives.length && this.singleDrives.name !== null) || !this.mulitDrives.length) {
                this.boxFrom = "box-shake";
                setTimeout(() => {
                    this.boxFrom = "box-shakeOrigin";
                }, 100);
            } else if (!this.singleDrives.name) {
                this.boxTo = "box-shake";
                setTimeout(() => {
                    this.boxTo = "box-shakeOrigin";
                }, 100);
            }
        },
        //立即传输请求
        transferNowRequest(addData) {
            let that = this;
            if (that.addTaskFlag) {
                that.addTaskFlag = false;
                that.loading = true;
                //如果源数据大于200条，则显示弹框
                if(addData.fromItems.length>200){
                      that.$toast({
                            text: this.$t('language.cloudTransfer.sourceRemind'),
                            type: 'fail',
                            idValue: "emailTransfer"
                        });
                    that.loading=false;
                    that.addTaskFlag = true;
                    return false;
                }
                //如果整体的未分组的数据超过5000，则显示弹窗
                if(this.$store.state.taskListNotGropArr.length>=5000){
                      that.$toast({
                            text: this.$t('language.exception.maxTaskRemind'),
                            type: 'fail',
                            idValue: "emailTransfer"
                        });
                    that.loading=false;
                    that.addTaskFlag = true;
                    return false;
                }
                //调用添加数据接口
                that.Utils.doTasksRequest('add', addData).then(res => {
                    that.addTaskFlag = true;
                    if (res.status == 200) {
                        //添加数据成功
                        taskListUtils.exeSuccessEnd('transferFlow','taskList',res.tasks,that);
                    } else if (res.status == 400 && res.reason == 'notEnoughTimes'){
                        that.loading = false;
                        //弹出付费弹窗
                        var upgradeNewDialog = this.$refs.upgradeNewDialog;
                        upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_pdf');
                        upgradeNewDialog.curItem = 'pdf';
                        upgradeNewDialog.isShow = true;
                    } else {
                        that.loading = false;
                        that.$toast({
                            text: res.msg,
                            type: 'fail',
                            idValue: "emailTransfer"
                        });
                    }
                });
            }
        },
        //仅仅添加传输任务
        transferAddTask() {
            //判断是否是临时用户，然后提醒用户进行绑定邮箱
            let user=commonUtils.getUser();
            if(commonUtils.testUserIsTourist(user)){
                this.$refs.remindBindEmailDialog.remindBindEmailShow=true;
                return false;
            }
            this.autoSubmit();
            if (this.mulitDrives.length && this.singleDrives.name) {
                let that = this;
                //流量不足弹窗提醒
                 let usedTraffic = user.usedBytes;
                //  if(user.vip&&user.payLevel>1){
                //      usedTraffic = user.payUsedTraffic;
                //   }
                if (user.totalBytes != -1 && usedTraffic >= user.totalBytes) {
                    var upgradeNewDialog = this.$refs.upgradeNewDialog;
                    upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_traffic');
                    upgradeNewDialog.curItem = 'traffic';
                    upgradeNewDialog.isShow = true;
                    return false;
                }
                let matched = this.$refs.filterOptionDialog.getFilterRule();
                if(matched){
                    this.pOptions.matched = matched
                    this.pOptions.pattern = "gmailFilter";
                }
                let addData = new taskTransferUtils.addTaskData(user.id ,1,this.inputValue, taskTransferUtils.createTransferFromItems(this.mulitDrives), taskTransferUtils.createTransferToItems(this.singleDrives), this.pOptions, this.pSchedules);
                addData.options.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;//传时区
                 //添加的源数据不能超过200条
                 if(addData.fromItems.length>200){
                      that.$toast({
                            text: this.$t('language.cloudTransfer.sourceRemind'),
                            type: 'fail',
                            idValue: "emailTransfer"
                        });
                    that.loading=false;
                    return false;
                }
                  if(this.$store.state.taskListNotGropArr.length>=5000){
                      that.$toast({
                            text: this.$t('language.exception.maxTaskRemind'),
                            type: 'fail',
                            idValue: "emailTransfer"
                        });
                    that.loading=false;
                    return false;
                }
                if (!addData.n) {
                    this.$refs.editInput.cancelTaskName();
                    addData.n = this.$refs.editInput.oldNameValue;
                }
                if (addData.fromItems.length >= 11 && addData.options.email) {
                    this.$refs.noticeDialog.noticeShow = true;
                    this.$refs.noticeDialog.transferFlag = 1;
                    this.$refs.noticeDialog.addData = addData;
                } else {
                    this.$nextTick(function () {
                        this.doAddTasksRequest(addData);
                    });
                }
            } else if ((!this.mulitDrives.length && !this.singleDrives.name) || !this.mulitDrives.length) {
                this.boxFrom = "box-shake";
                setTimeout(() => {
                    this.boxFrom = "box-shakeOrigin";
                }, 100);
            } else if (!this.singleDrives.name) {
                this.boxTo = "box-shake";
                setTimeout(() => {
                    this.boxTo = "box-shakeOrigin";
                }, 100);
            }
        },
        //添加传输任务并立即执行
        addTransferNow() {
            //判断是否是临时用户，然后提醒用户进行绑定邮箱
            let user=commonUtils.getUser();
            if(commonUtils.testUserIsTourist(user)){
                this.$refs.remindBindEmailDialog.remindBindEmailShow=true;
                return false;
            }
            this.autoSubmit();
            if (this.mulitDrives.length && this.singleDrives.name) {
                let that = this;
                //流量不足弹窗提醒
                let usedTraffic = user.usedBytes;
                // if(user.vip&&user.payLevel>1){
                //  usedTraffic = user.payUsedTraffic;
                // }
                if (user.totalBytes != -1 && usedTraffic >= user.totalBytes) {
                    var upgradeNewDialog = this.$refs.upgradeNewDialog;
                    upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_traffic');
                    upgradeNewDialog.curItem = 'traffic';
                    upgradeNewDialog.isShow = true;
                    return false;
                }
                let matched = this.$refs.filterOptionDialog.getFilterRule();
                if(matched){
                    this.pOptions.matched = matched
                    this.pOptions.pattern = "gmailFilter";
                }
                let addData = new taskTransferUtils.addTaskData(user.id ,1,this.inputValue, taskTransferUtils.createTransferFromItems(this.mulitDrives), taskTransferUtils.createTransferToItems(this.singleDrives), this.pOptions, this.pSchedules);
                addData.options.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;//传时区
                if(addData.fromItems.length>200){
                      that.$toast({
                            text: this.$t('language.cloudTransfer.sourceRemind'),
                            type: 'fail',
                            idValue: "emailTransfer"
                        });
                    that.loading=false;
                    return false;
                }
                if(this.$store.state.taskListNotGropArr.length>=5000){
                      that.$toast({
                            text: this.$t('language.exception.maxTaskRemind'),
                            type: 'fail',
                            idValue: "emailTransfer"
                        });
                    that.loading=false;
                    return false;
                }

               if (!addData.n) {
                    this.$refs.editInput.cancelTaskName();
                    addData.n = this.$refs.editInput.oldNameValue;
                }
                if (addData.fromItems.length >= 11 && addData.options.email) {
                    this.$refs.noticeDialog.noticeShow = true;
                    this.$refs.noticeDialog.transferFlag = 2;
                    this.$refs.noticeDialog.addData = addData;
                } else {
                    this.$nextTick(() => {
                        this.addTaskAndTransferNowRequest(addData);
                    });
                }
            } else if ((!this.mulitDrives.length && !this.singleDrives.name) || !this.mulitDrives.length) {
                this.boxFrom = "box-shake";
                setTimeout(() => {
                    this.boxFrom = "box-shakeOrigin";
                }, 100);
            } else if (!this.singleDrives.name) {
                this.boxTo = "box-shake";
                setTimeout(() => {
                    this.boxTo = "box-shakeOrigin";
                }, 100);

            }
        },
        //添加任务并立即传输请求
        addTaskAndTransferNowRequest(addData) {
            let that = this;
            let executeData;
            if (that.addTaskFlag) {
                that.addTaskFlag = false;
                that.Utils.doTasksRequest('add', addData).then(res => {
                    that.addTaskFlag = true;
                    if (res.status == 200) {
                        if (res.group_id) {
                            executeData=new taskListUtils.executeData(commonUtils.getUser().id,1,null,res.group_id);
                        } else {
                            executeData=new taskListUtils.executeData(commonUtils.getUser().id,1,res.tasks[0].id,null);
                        }
                        taskListUtils.addLength(this);
                        that.doExeCuteTasksRequest(executeData,res.tasks);
                        that.checkedSchedule = false;
                    } else if (res.status == 400 && res.reason == 'notEnoughTimes'){
                        //弹出付费弹窗
                        var upgradeNewDialog = this.$refs.upgradeNewDialog;
                        upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_pdf');
                        upgradeNewDialog.curItem = 'pdf';
                        upgradeNewDialog.isShow = true;
                    } else {
                        that.$toast({
                            text: res.msg,
                            type: 'fail',
                            idValue: "emailTransfer"
                        });
                    }
                });
            }
        },
        doAddTasksRequest(addData) {
            let that = this;
            if (that.addTaskFlag) {
                that.loading = true;
                that.addTaskFlag = false;
                that.Utils.doTasksRequest('add', addData).then(res => {
                    that.addTaskFlag = true;
                    if (res.status == 200) {
                        taskListUtils.exeSuccessEnd('transferFlow','taskList',res.tasks,that);
                    } else if (res.status == 400 && res.reason == 'notEnoughTimes'){
                        that.loading = false;
                        //弹出付费弹窗
                        var upgradeNewDialog = this.$refs.upgradeNewDialog;
                        upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_pdf');
                        upgradeNewDialog.curItem = 'pdf';
                        upgradeNewDialog.isShow = true;
                    } else {
                        that.loading = false;
                        that.$toast({
                            text: res.msg,
                            type: 'fail',
                            idValue: "emailTransfer"
                        });
                    }
                });
            }
        },
        doExeCuteTasksRequest(executeData,tasks) {
            let that = this;
            if (that.addTaskFlag) {
                that.loading = true;
                that.addTaskFlag = false;
                that.Utils.doTasksRequest('execute', executeData).then(res => {
                    that.addTaskFlag = true;
                    if (res.status == 200) {
                      $.each(tasks,function(i,item){
                          item.status='Waiting';
                      });
                       taskListUtils.exeSuccessEnd('transferFlow','taskList',tasks,that);
                    } else if (res.status == 400 && res.reason == 'notEnoughTimes'){
                        that.loading = false;
                        //弹出付费弹窗
                        var upgradeNewDialog = that.$refs.upgradeNewDialog;
                        upgradeNewDialog.title = that.$t('language.paySystem.freePlanPopup.title_pdf');
                        upgradeNewDialog.curItem = 'pdf';
                        upgradeNewDialog.isShow = true;
                    } else {
                        that.loading = false;
                        that.$toast({
                            text: res.msg,
                            type: 'fail',
                            idValue: "emailTransfer"
                        });
                    }
                });
            }
        },
        clearPageChoose() {
            let that = this;
            that.mulitDrives = [];
            that.singleDrives = {};
            that.hasSelectItemsMore = false;
            that.hasSelectItems = false;
            that.hasSelect = true;
            that.checkedSchedule = false;
            that.addTaskShow = false;
            let sourceDialog = that.$refs.transferAimTree;
            let aimDialog = that.$refs.transferSourceTree;
            that.$refs.transferAimTree.checkedNodes = [];
            that.$refs.transferSourceTree.checkedNodes = [];
            //重置
            that.$refs.transferAimTree.refresh();
            that.$store.state.syncClickItem = -1;
            that.$store.state.clickItem = -1;
            that.$store.state.syncArr = [];
            that.$store.state.arr = [];
            //收拢两个树形弹窗
            for (var i = 0; i < sourceDialog.$refs.tree.store._getAllNodes().length; i++) {
                sourceDialog.$refs.tree.store._getAllNodes()[i].expanded = false;
            }
            commonUtils.closeTree(aimDialog.model);
            let div1=this.$refs.scrollbarAim.wrap;
            let div2=this.$refs.scrollbarSource.wrap;
            that.$nextTick(() => {
                div1.scrollTop=0;
                div2.scrollTop=0;     
            });
            sourceDialog.scrollTopValue = 0;
            aimDialog.scrollTopValue = 0
            that.$refs.transferOptionsDialog.clearAllData();
            that.$refs.transferScheduleDialog.initPopup();
            that.$refs.filterOptionDialog.reset();
        },

    }
};
</script>

<style>
.transfer-right-body {
    width: 100%;
    height: calc(100% - 90px);
    /*no*/
    background-color: #f2f7fe !important;
    position: relative;
    top: 90Px;
    overflow-x:hidden;
}

/*定义滑块，内阴影及圆角*/

.transfer-right-body::-webkit-scrollbar {
    width: 9px;
    /*no*/
    height: 9px;
    /*no*/
    background-color: #fff;
}

.transfer-right-body::-webkit-scrollbar-thumb {
    height: 1px;
    /*no*/
    border-radius: 5px;
    /*no*/
    background-color: #becae4;
}

#emailTransfer .el-loading-spinner i {
    color: #999999;
}

#emailTransfer .task-box .el-loading-spinner {
    /* font-size: 45px; */
    /*no*/
    top: 0; 
    margin-top: 0;
}

#emailTransfer .task-box, #emailTransfer .task-box-middle{
    height: 100%;
    /*no*/
    cursor: unset;
}

#emailTransfer .task-box-btns {
    cursor: pointer;
    width: fit-content;
}

#emailTransfer .task-box-btns-icon {
    margin: auto 10px auto 0;/*no*/
}

#emailTransfer .definite-operating {
    bottom: -30px;/*no*/
    height: auto;
    padding: 0;
    z-index: 1;
}

#emailTransfer #pleaseSelect,
#emailTransfer #sourceSelect {
    height: auto !important;
    width: auto !important;
}

#emailTransfer .task-box .el-loading-spinner .circular {
    height: 25px !important;/*no*/
    width: 25px !important;/*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/email_transfer.vue